import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import { createPortal } from 'react-dom';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialView: 'login' | 'signup';
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose, initialView }) => {
  const { mode } = useTheme();
  const [view, setView] = useState<'login' | 'signup'>(initialView);
  const isFairyTheme = mode === 'fairy';
  const isNeonTheme = mode === 'neon';

  // Update view when initialView changes
  useEffect(() => {
    setView(initialView);
  }, [initialView]);

  if (!isOpen) return null;

  const modalContent = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div
        className={`relative z-[10000] w-full max-w-md mx-4 rounded-xl shadow-xl ${isNeonTheme
          ? 'bg-black border border-[#00FF00]/20'
          : isFairyTheme
            ? 'bg-[#1a1625]/95'
            : 'bg-gray-800'
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className={`absolute top-4 right-4 ${isFairyTheme ? 'text-purple-200 hover:text-purple-100' : mode === 'neon' ? 'text-[#00FF00]/80 hover:text-[#00FF00]' : 'text-gray-400 hover:text-white'} transition-colors`}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Content */}
        {view === 'login' ? (
          <LoginForm onClose={onClose} onSwitchToSignUp={() => setView('signup')} />
        ) : (
          <SignUpForm onClose={onClose} onSwitchToLogin={() => setView('login')} />
        )}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default AuthModal; 